/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
  locale,
} = require('../.private').components;

module.exports = {
  exportDrawSystemGameTypeReportByCompositeKey: {
    properties: {
      body: {
        properties: {
          locale,
        },
        required: ['locale'],
        type: 'object',
      },
      params: {
        properties: {
          compositeKey,
        },
        required: ['compositeKey'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeReportByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
        },
        required: ['compositeKey'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
